// extracted by mini-css-extract-plugin
export default {"project-tile":"ProjectTile_project-tile__LzrAO","slide-down":"ProjectTile_slide-down__57rJF","slide-up":"ProjectTile_slide-up__Cox71"};